module.exports = __webpack_public_path__ + "img/kf.156d1bfc.png";